import { Component, OnInit, ViewChild } from '@angular/core';
import { SessionService } from '../../services/session.service';
import { PlatformApiService } from '../../services/platform-api.service';
import { Account, AccountType } from '../../models/AccountModel';
import { AccountListComponent } from '../admin/account-list.component';
import { SettingsWizardComponent } from '../settings-wizard/settings-wizard-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cw-ci-admin-account-dashboard',
  templateUrl: './admin-account-dashboard.component.html',
  styleUrls: ['./admin-account-dashboard.component.scss']
})
export class AdminAccountDashboardComponent implements OnInit {
  state='LIST';
  selectedAccount: Account;
  parentAccount: Account;

  @ViewChild(AccountListComponent) accountList: AccountListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService, public dialog: MatDialog) { }

  ngOnInit() {
    if (this._sessionService.getCurrentAccount().type != AccountType.SYSTEM) {
      this.parentAccount = this._sessionService.getCurrentAccount();
    }
  }

  showList() {
    this.selectedAccount = undefined;
    this.state = 'LIST'
  }

  deleteAccount(account) {
    this._platformApi.deleteAccount(account.id).subscribe(
      resp => {
        this.accountList.loadAccounts();
      }
    );
  }

  onStateChange(event) {
    let dialogRef;
    switch(event.state) {
      case 'CREATE':
        const newAccount = new Account({type: AccountType.COMPANY});
        if (this._sessionService.getCurrentAccount().type != AccountType.SYSTEM) {
          const currentAccount = this._sessionService.getCurrentAccount()
          newAccount.parentId = currentAccount.id;
          newAccount.masterPlanSubscription = currentAccount.planSubscription;
        }
        dialogRef = this.dialog.open(SettingsWizardComponent, {
          panelClass: 'flush-dialog',
          disableClose: true,
          autoFocus: false,
          data: {
            selectedAccount: newAccount,
            startingMenuItem: 'ACCOUNT_START'
          }
        });
        dialogRef.afterClosed().subscribe(() => {
          this.accountList.refresh();
        });
        break;
        case 'SELECT':
      case 'EDIT':
        let parentAccount;
        if(event.item.parentId) {
          parentAccount = new Account({id:event.item.parentId});
        }
        dialogRef = this.dialog.open(SettingsWizardComponent, {
          panelClass: 'flush-dialog',
          disableClose: true,
          autoFocus: false,
          data: {
            selectedAccount: event.item,
            parentAccount,
            startingMenuItem: 'ACCOUNT_START'
          }
        });
        dialogRef.afterClosed().subscribe(() => {
          this.accountList.refresh();
        });
        break;
      case 'DELETE':
        this.deleteAccount(event.item);
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedAccount = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
